"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var CancellationPolicyStageTooltip = function CancellationPolicyStageTooltip(props) {
  var className = props.className,
    text = props.text,
    isFullProgress = props.isFullProgress;
  return /*#__PURE__*/_react["default"].createElement(StyledTooltip, {
    className: className,
    isFullProgress: isFullProgress
  }, text);
};
var StyledTooltip = _styledComponents["default"].div.withConfig({
  displayName: "CancellationPolicyStageTooltip__StyledTooltip",
  componentId: "sc-9352lr-0"
})(["background:#ffffff;border-radius:12px;color:", ";font-weight:500;font-size:12px;line-height:16px;filter:drop-shadow(0px 2px 4px rgba(210,208,197,0.8));position:absolute;top:0;z-index:100;white-space:nowrap;padding:3px 8px 5px;top:-29px;left:0;transform:", ";::after{content:'';position:absolute;left:calc(50% - 4px);top:100%;width:0;height:0;border-left:5px solid transparent;border-right:5px solid transparent;border-top:5px solid #fff;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.blackBase;
}, function (_ref2) {
  var isFullProgress = _ref2.isFullProgress;
  return isFullProgress ? 'translateX(0%)' : 'translateX(-50%)';
});
var _default = exports["default"] = CancellationPolicyStageTooltip;